// extracted by mini-css-extract-plugin
export default {"listElement":"ListElement_listElement__bpYRq","alt":"ListElement_alt__fWT3l"};